import { useEffect, useMemo, useState } from "react";
import {
  Col,
  Row,
  Form,
  message,
  Button,
  DatePicker,
  Select,
  Switch,
  TimePicker,
} from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useNavigate } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import moment from "moment";
import { useSelector } from "react-redux";
import { Get, Post } from "../../../config/api";
import { BOOKING, SUBSCRIPTION } from "../../../config/constants/api";
import swal from "sweetalert";

dayjs.extend(customParseFormat);

const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent4 = () => {
  const userData = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [subscription, setSubscription] = useState(null);
  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [pickupLocation, setPickupLocation] = useState({
    address: "",
    coordinates: [0, 0],
    type: "Point",
  });
  const fetchActiveSubscription = async () => {
    Get(SUBSCRIPTION.fetchActiveSubscription, token).then((response) => {
      if(response?.status){
        setSubscription(response?.data);
      }
    }).catch((error) => {
      console.log(error, "error");
    })
  }
  const [dropoffLocation, setDropoffLocation] = useState({
    address: "",
    coordinates: [0, 0],
    type: "Point",
  });
  useEffect(() => {
    if(token){
      fetchActiveSubscription();
    }
  },[])
  const [form] = Form.useForm();
  const [startFocused, setStartFocused] = useState(false);
  const [destinationFocused, setDestinationFocused] = useState(false);
  const [isDropOffVisible, setIsDropOffVisible] = useState(false);
  const navigate = useNavigate();
  const onChange = (checked) => {
    setIsDropOffVisible(!checked);
  };
  const onFinish = async (values) => {
    const selectedDateTime = moment(
      `${moment(values?.date?.$d).format("YYYY-MM-DD")} ${moment(
        values?.time?.$d
      ).format("HH:mm:ss")}`
    );

    const now = moment();
    const oneHourBuffer = now.clone().startOf("hour"); // Start of the current hour

    if (selectedDateTime.isBefore(oneHourBuffer)) {
      return message.error(
        "You cannot select a past date or time. Please select within the current hour or later."
      );
    }

    let miles = 0;
    if (isDropOffVisible) {
      let distance = await fetchDirectionsAndDistance();
      let distanceInKm = Number(distance.distance.text.split(" ")[0]);
      miles = distanceInKm * 0.621371;
    }
    let data = {
      type: isDropOffVisible ? "PtoP" : "Hourly",
      date: moment(values?.date?.$d).format("YYYY-MM-DD"),
      time: moment(values?.time?.$d).format("YYYY-MM-DD HH:mm"),
      pickupLocation: pickupLocation,
      dropoffLocation: isDropOffVisible ? dropoffLocation : null,
      duration: values?.duration || 0,
      initialMileage: miles,
    };
    if(subscription){
      data.customerName =  userData?.firstName
      ? userData?.firstName + " " + userData?.lastName
      : "-";
      data.serviceType = subscription?.serviceType;
      data.passengerCapacity = subscription?.passengerCapacity;
      Post(BOOKING.bookChauffeur, data, token)
      .then((response) => {
        if (response?.status) {
          form.resetFields();
          swal( 
            "Success",
            "Your Booking is Confirmed",
            "success"
          );
        }
      })
      .catch((err) => {
        console.log(err);
        let message = err?.response?.data?.message || err?.message;
        if (message) {
          swal("Error", message, "error");
        }
      });
    }
    else{
      navigate("/recent", { state: { data: data } });
    }
  };

  const getDurationOptions = (subscription) => {
    if (subscription?.plan?.title === "Yearly Membership") {
      // If subscription plan is "Yearly Membership"
      return [
        {
          value: "8",
          label: "8 Hours",
        },
      ];
    } else if (subscription) {
      // If subscription exists but is not "Yearly Membership"
      return [
        {
          value: "6",
          label: "6 Hours",
        },
        {
          value: "7",
          label: "7 Hours",
        },
        {
          value: "8",
          label: "8 Hours",
        },
      ];
    } else {
      // If subscription does not exist
      return [
        {
          value: "4",
          label: "4 Hours",
        },
        {
          value: "5",
          label: "5 Hours",
        },
        {
          value: "6",
          label: "6 Hours",
        },
        {
          value: "7",
          label: "7 Hours",
        },
        {
          value: "8",
          label: "8 Hours",
        },
      ];
    }
  };
  
  const pickupCoordinates = useMemo(
    () => ({
      lat: pickupLocation.coordinates[1],
      lng: pickupLocation.coordinates[0],
    }),
    [pickupLocation]
  );
  const dropoffCoordinates = useMemo(
    () => ({
      lat: dropoffLocation?.coordinates[1],
      lng: dropoffLocation?.coordinates[0],
    }),
    [dropoffLocation]
  );

  const fetchDirectionsAndDistance = async () => {
    try {
      if (window.google && window.google.maps) {
        const distanceMatrixService =
          new window.google.maps.DistanceMatrixService();

        // Fetch Distance Matrix
        return new Promise((resolve, reject) => {
          distanceMatrixService.getDistanceMatrix(
            {
              origins: [pickupCoordinates],
              destinations: [dropoffCoordinates],
              travelMode: window.google.maps.TravelMode.DRIVING,
            },
            (response, status) => {
              if (status === window.google.maps.DistanceMatrixStatus.OK) {
                const distanceData = response.rows[0]?.elements[0];
                console.log(distanceData, "distanceData");
                if (
                  distanceData &&
                  distanceData.distance &&
                  distanceData.duration
                ) {
                  const durationText = distanceData.duration.text;
                  resolve(distanceData); // Return the distanceData
                } else {
                  console.log("Distance data is missing in the response.");
                  message.error("Distance data is missing in the response.");
                  reject("Distance data is missing.");
                }
              } else {
                console.log(`Error fetching distance matrix: ${status}`);
                message.error(
                  `Error fetching distance matrix: ${status}. Please try again.`
                );
                reject(`Error fetching distance matrix: ${status}`);
              }
            }
          );
        });
      } else {
        console.log("Google Maps API is not loaded.");
        message.error("Google Maps API is not loaded. Please try again later.");
        throw new Error("Google Maps API is not loaded.");
      }
    } catch (error) {
      console.log("Error fetching directions or distance matrix:", error);
      message.error("Error fetching data. Please try again.");
      throw error;
    }
  };
  const onChangedate = (date, dateString) => {
    // console.log(date, dateString);
  };

  const onChangetime = (time, timeString) => {
    // console.log(time, timeString);
  };

  const handleChange = (value) => {
    // console.log(`selected ${value}`);
  };

  const handlePickupSelect = (newAddress) => {
    setPickupLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
    form.setFieldsValue({
      pickupLocation: newAddress,
    });

    geocodeByAddress(newAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setPickupLocation((prevLocation) => ({
          ...prevLocation,
          address: newAddress,
          coordinates: [latLng?.lng, latLng?.lat],
        }));
      })
      .catch((error) => console.error("Error", error));
  };
  const handleDestSelect = (newAddress) => {
    setDropoffLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
    form.setFieldsValue({
      dropoffLocation: newAddress,
    });

    geocodeByAddress(newAddress)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setDropoffLocation((prevLocation) => ({
          ...prevLocation,
          address: newAddress,
          coordinates: [latLng?.lng, latLng?.lat],
        }));
      })
      .catch((error) => console.error("Error", error));
  };
  const handlePickupLocChange = (newAddress) => {
    setPickupLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
  };
  const handleDestLocChange = (newAddress) => {
    setDropoffLocation((prevLocation) => ({
      ...prevLocation,
      address: newAddress,
    }));
  };

  const handleStartFocus = () => {
    setStartFocused(true);
  };

  const handleStartBlur = () => {
    setStartFocused(false);
  };
  const handleDestinationFocus = () => {
    setDestinationFocused(true);
  };

  const handleDestinationBlur = () => {
    setDestinationFocused(false);
  };
  return (
    < >
  
      <Row justify="center" align={"middle"} className="pt-4 mb-6" style={{ minHeight: "30vh" }}>
        <Col xxl={18} md={20} sm={20} xs={20}>
          <Form
            layout="vertical"
            name="basic"
            initialValues={{
              remember: true,
              duration: "6",
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            className="bg-[#141313e6] rounded-[10px]  md:pb-4 sm:pb-4 home-form"
            // className="bg-[#00000036] rounded-[10px] lg:pb-0 md:pb-4 sm:pb-4 home-form"
            form={form}
          >
            <Row justify={"center"} className="mt-0">
              <Col lg={21}>
                <div className="mt-4 mx-4  flex flex-col items-baseline">
                  <h4 className="text-white font-goldman text-[18px] pb-2">
                  {isDropOffVisible ? "Book by Distance" : "Book by Hours"}
                </h4>
                  <Switch onChange={onChange} defaultChecked disabled={true}/>
                </div>
                {/* Conditional text rendering based on switch state */}
              
                <div className="flex flex-wrap gap-4 py-8 px-4">
                  <Form.Item
                    label="Pick Up Date"
                    name="date"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input date!",
                      },
                    ]}
                  >
                    <DatePicker
                      disabledDate={(current) => {
                        let customDate = moment().format("YYYY-MM-DD");
                        return (
                          current && current < moment(customDate, "YYYY-MM-DD")
                        );
                      }}
                      onChange={onChangedate}
                      className="web-input w-full"
                      format="MM/DD/YYYY"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Pick Up time"
                    name="time"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input time!",
                      },
                    ]}
                  >
                    <TimePicker
                      key={form.getFieldValue("date")}
                      onChange={onChangetime}
                      defaultOpenValue={dayjs("00:00", "HH:mm")}
                      format="h:mm A" 
                      className="web-input w-full"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Pick Up Location"
                    name="pickupLocation"
                    className="flex-1 min-w-[180px] mb-0"
                    rules={[
                      {
                        required: true,
                        message: "Please input location!",
                      },
                    ]}
                  >
                    <PlacesAutocomplete
                      value={pickupLocation?.address}
                      onChange={handlePickupLocChange}
                      onSelect={handlePickupSelect}
                    >
                      {({
                        getInputProps,
                        suggestions,
                        getSuggestionItemProps,
                        loading,
                      }) => {
                        return (
                          <div className="location-drop">
                            <input
                              {...getInputProps({
                                className: "web-input",
                                placeholder: "Search Pickup Location",
                                onFocus: handleStartFocus,
                                onBlur: handleStartBlur,
                              })}
                            />
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map((suggestion) => {
                                const className = suggestion.active
                                  ? "suggestion-item--active googleSuggestion"
                                  : "suggestion-item googleSuggestion";
                                const style = suggestion.active
                                  ? {
                                      backgroundColor: "#fafafa",
                                      cursor: "pointer",
                                      padding: "5px 10px",
                                    }
                                  : {
                                      backgroundColor: "#ffffff",
                                      cursor: "pointer",
                                      padding: "5px 10px",
                                    };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      }}
                    </PlacesAutocomplete>
                  </Form.Item>

                  {isDropOffVisible && (
                    <Form.Item
                      label="Drop Off Location"
                      name="dropoffLocation"
                      className="flex-1 min-w-[180px] mb-0"
                      rules={[
                        {
                          required: true,
                          message: "Please input your drop location!",
                        },
                      ]}
                    >
                      <PlacesAutocomplete
                        value={dropoffLocation?.address}
                        onChange={handleDestLocChange}
                        onSelect={handleDestSelect}
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => {
                          return (
                            <div className="location-drop">
                              <input
                                {...getInputProps({
                                  placeholder: "Search Dropoff Location",
                                  className: "web-input",
                                  onFocus: handleDestinationFocus,
                                  onBlur: handleDestinationBlur,
                                })}
                              />
                              <div className="autocomplete-dropdown-container">
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion) => {
                                  const className = suggestion.active
                                    ? "suggestion-item--active googleSuggestion"
                                    : "suggestion-item googleSuggestion";
                                  const style = suggestion.active
                                    ? {
                                        backgroundColor: "#fafafa",
                                        cursor: "pointer",
                                        padding: "5px 10px",
                                      }
                                    : {
                                        backgroundColor: "#ffffff",
                                        cursor: "pointer",
                                        padding: "5px 10px",
                                      };
                                  return (
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className,
                                        style,
                                      })}
                                    >
                                      <span>{suggestion.description}</span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          );
                        }}
                      </PlacesAutocomplete>
                    </Form.Item>
                  )}

                  {!isDropOffVisible &&<Form.Item
                    label="Duration"
                    name="duration"
                    className="flex-1 min-w-[180px] mb-0"
                  >
                    <Select
                      className="web-inputv"
                      onChange={handleChange}
                      // options={[
                      //   {
                      //     value: "6",
                      //     label: "6 Hours",
                      //   },
                      //   {
                      //     value: "7",
                      //     label: "7 Hours",
                      //   },
                      //   {
                      //     value: "8",
                      //     label: "8 Hours",
                      //   },
                      // ]}
                      options={getDurationOptions(subscription)}

                    />
                  </Form.Item>}
                </div>
              </Col>
              <Col xl={16} lg={18} md={20}>
                <Form.Item className="mb-0 h-full full-h-btn">
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="web-btn text-black hover:transform-none w-full h-full py-2"
                    style={{fontSize:'18px'}}
                  >
                   {subscription ? 'Book Chauffeur' : 'Find A Chauffeur'}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default HomeComponent4;
